// /treasury/fees → /treasury/fees/policies. The bare section URL (and
// every pre-split bookmark) lands on the Policies page.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/treasury/fees/")({
  beforeLoad: () => {
    throw redirect({ to: "/treasury/fees/policies", replace: true });
  },
});
